// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavoriteBadge__HhBwcZvmjJh0w_TZNro{color:#fff}.FavoriteBadge__HhBwcZvmjJh0w_TZNro:hover,.FavoriteBadge__HhBwcZvmjJh0w_TZNro:focus-visible{transform:scale(1.2)}`, "",{"version":3,"sources":["webpack://./src/components/FavoriteBadge/FavoriteBadge.module.scss"],"names":[],"mappings":"AAAA,oCACE,UAAA,CAEA,4FAEE,oBAAA","sourcesContent":[".FavoriteBadge {\n  color: white;\n\n  &:hover,\n  &:focus-visible {\n    transform: scale(1.2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FavoriteBadge": `FavoriteBadge__HhBwcZvmjJh0w_TZNro`
};
export default ___CSS_LOADER_EXPORT___;
